import * as React from 'react';
import {Query} from 'react-apollo';
import {Link, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';
// @ts-expect-error
import {components, createFilter} from 'react-select';
// @ts-expect-error
import type {OptionProps} from 'react-select';

import {formatTimestampAsAbbrevMonth} from 'nutshell-core/date-time/formatting';

// @ts-expect-error - imported from .js/.jsx file

import {EmailIcon} from 'shells/icon/svg/email-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EmailSeriesIcon} from 'shells/icon/svg/email-series-icon';

import type {
    SalesAutomationableEmailSequenceTemplates as SalesAutomationableEmailSequenceTemplatesQuery,
    SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates,
} from 'nutshell-graphql-types';

import {GraphQLSelect} from './graphql-select';
import GET_SALES_AUTOMATIONABLE_EMAIL_SEQUENCES from './queries/sales-automationable-email-sequence-templates.graphql';

import styles from './graphql-select-sales-automationable-email-sequence-templates.module.css';

const MANAGE_TEMPLATES_OPTION_ID = 'manageTemplates';
const MANAGE_TEMPLATES_PATH = '/email/templates';

class GetSalesAutomationableEmailSequencesQuery extends Query<
    SalesAutomationableEmailSequenceTemplatesQuery,
    Record<any, any>
> {}

type OwnProps = {
    inputId?: string;
    selectedId: string | null | undefined;
    currentTemplate:
        | SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates
        | null
        | undefined;
    stagesetId: string;
    onChange: (newValue: any) => any;
    onClearValue?: () => void;
    labelKey?: string;
    valueKey?: string;
    autoFocus?: boolean;
    autoBlur?: boolean;
    isLoading?: boolean;
    noResultsText?: string;
    styles?: any;
    menuPortalTarget?: HTMLElement;
    defaultsToFirstItem?: boolean;
};

type Props = OwnProps & ContextRouter;

// @ts-expect-error
export const GraphQLSelectSalesAutomationableEmailSequenceTemplates = withRouter<OwnProps>(
    (props: Props) => {
        const {history, onChange} = props;
        const handleChange = React.useCallback(
            (newValue) => {
                if (newValue.id === MANAGE_TEMPLATES_OPTION_ID) {
                    history.push(MANAGE_TEMPLATES_PATH);
                }
                onChange(newValue);
            },
            [history, onChange]
        );

        return (
            <GetSalesAutomationableEmailSequencesQuery
                query={GET_SALES_AUTOMATIONABLE_EMAIL_SEQUENCES}
                variables={{stagesetId: props.stagesetId}}
                // @ts-expect-error
                fetchPolicy='cache-and-network'
            >
                {({data, loading}) => {
                    const salesAutomationableEmailSequenceTemplates =
                        data && data.salesAutomationableEmailSequenceTemplates
                            ? data.salesAutomationableEmailSequenceTemplates
                                  .map((template) => ({
                                      ...template,
                                      isDisabled: template.hasCustomPlaceholders,
                                  }))
                                  .sort((template) => (template.isDisabled ? 1 : -1))
                            : [];

                    const options = [
                        {id: MANAGE_TEMPLATES_OPTION_ID},
                        ...salesAutomationableEmailSequenceTemplates,
                    ];

                    if (props.currentTemplate) {
                        options.splice(1, 0, props.currentTemplate);
                    }

                    return (
                        <GraphQLSelect
                            {...props}
                            isLoading={loading}
                            placeholder='Start from a template…'
                            noResultsText='No templates found'
                            openMenuOnFocus={true}
                            clearable={true}
                            models={options}
                            filterOption={customFilterOption}
                            onChange={handleChange}
                            components={{
                                Option: OptionComponent,
                            }}
                        />
                    );
                }}
            </GetSalesAutomationableEmailSequencesQuery>
        );
    }
);

function OptionComponent(props: OptionProps) {
    if (props.data.id === MANAGE_TEMPLATES_OPTION_ID) {
        return (
            <components.Option {...props}>
                <div className={styles['manage-templates']}>
                    {/* @ts-expect-error */}
                    <Link to={MANAGE_TEMPLATES_PATH}>- Manage templates -</Link>
                </div>
            </components.Option>
        );
    }
    const sequenceName = props.data.name;
    const creatorName = props.data.creatorUser.name || 'a teammate';
    const createdTime = formatTimestampAsAbbrevMonth(props.data.createdTime);
    const Icon = props.data.emailSequenceTemplateMessages.length > 1 ? EmailSeriesIcon : EmailIcon;
    const subtitle = props.data.isDisabled
        ? 'Templates with placeholders cannot be automated'
        : `Created by ${creatorName} ${createdTime}`;

    return (
        <components.Option {...props}>
            <div className={props.data.isDisabled ? styles['option--disabled'] : undefined}>
                <div className={styles['option-title']}>{sequenceName}</div>
                <div className={styles['option-subtitle']}>
                    {props.data.isDisabled ? undefined : <Icon size={13} alignCenter={true} />}
                    {subtitle}
                </div>
            </div>
        </components.Option>
    );
}

const customFilterOption = (option: any, input: string) => {
    // Always show the manage templates option, even when searching
    if (option && option.data && option.data.id === MANAGE_TEMPLATES_OPTION_ID) {
        return true;
    }

    // Now use react-select's build in `createFilter` function,
    // but disable ignoreAccents, because it's really slow.
    const createFilterFunction = createFilter({
        ignoreCase: true,
        // `ignoreAccents: true` is very slow!!
        ignoreAccents: false,
        trim: true,
        matchFrom: 'any',
    });

    return createFilterFunction(option, input);
};
